// extracted by mini-css-extract-plugin
export default {"resourceLink":"referredDataValueInResourcePopup_resourceLink__lJE0H"};